import api from './api';

export const wishlistService = {
  getWishlist: async () => {
    const { data } = await api.get('/wishlist');
    return data;
  },

  toggleWishlist: async (productId) => {
    const { data } = await api.post(`/wishlist/${productId}`);
    return data;
  },

  removeFromWishlist: async (productId) => {
    await api.delete(`/wishlist/${productId}`);
    return true;
  }
};

export default wishlistService;
